// i18n catalog — AdminSubscriptions page (namespace: subs)
// One entry per user-facing STATIC string in pages/AdminSubscriptions.js.
// Values copied VERBATIM from the page for `en`; `ar` = accurate Modern
// Standard Arabic. Dynamic data, numbers, currency, platform/brand names are
// NOT included here (they stay interpolated in JSX).
export const en = {
  // ── CardRequiredModal ────────────────────────────────────────────────
  "subs.card.heading": "Add payment method to start trial",
  "subs.card.createOnReturn.prefix": "We'll create ",
  "subs.card.createOnReturn.suffix": " as soon as you're back.",
  "subs.card.createWorkspaceOnReturn": "We'll create your workspace as soon as you're back.",
  "subs.card.plan.monthly": "Monthly",
  "subs.card.plan.annualFree": "Annual · 1 month free",
  "subs.card.firstSite": "First Site",
  "subs.card.per.year": "yr",
  "subs.card.per.month": "mo",
  "subs.card.noChargeToday": "No charge today.",
  "subs.card.trialNote": " Billing starts only when your 7-day trial ends — cancel any time before then.",
  "subs.card.cta.redirecting": "Redirecting to Stripe…",
  "subs.card.cta.addStartTrial": "Add payment method · Start trial →",
  "subs.card.cta.skipTrial": "Skip trial · pay now & full access",
  "subs.card.cta.maybeLater": "Maybe later · I'll add card before creating workspace",
  "subs.card.err.notAuthenticated": "Not authenticated",
  "subs.card.err.checkoutFailed": "Checkout failed",
  "subs.card.err.noCheckoutUrl": "No checkout URL returned",
  "subs.card.alert.alreadySubscribed": "You already have an active subscription. Refreshing to load it.",

  // ── Alerts / errors (createWorkspace + actions) ──────────────────────
  "subs.alert.trialOneWorkspace": "Trial users can only create 1 workspace. Subscribe or skip trial to add more.",
  "subs.alert.freeOverrideOneWorkspace": "Free access includes 1 workspace. Subscribe to add more workspaces.",
  "subs.alert.saveFailed": "Failed to save workspace. Check your connection and try again.",
  "subs.alert.sessionExpired": "Your session has expired. Please log in again to create workspaces.",
  "subs.alert.couldNotDeletePrefix": "Could not delete workspace: ",
  "subs.alert.cardCouldNotCharge": "Your card couldn't be charged. The workspace was not created. Please update your payment method in Manage billing and try again.",
  "subs.alert.createFailed": "Failed to create workspace.",
  "subs.alert.createFailedRetry": "Failed to create workspace. Please try again.",
  "subs.alert.trialEndedSubscribe": "Your trial has ended. Please subscribe to restore this workspace.",
  "subs.err.nameEmpty": "Name can't be empty",
  "subs.err.couldntSaveName": "Couldn't save name",
  "subs.err.failedReactivate": "Failed to reactivate",
  "subs.err.failed": "Failed",
  "subs.err.failedDeleteWorkspace": "Failed to delete workspace",
  "subs.err.couldNotOpenPortal": "Could not open billing portal",
  "subs.err.lastWorkspaceManageBilling": "This is your only remaining workspace. Use 'Manage billing' to cancel your entire subscription.",
  "subs.err.cancelFailed": "Cancel failed",
  "subs.err.checkoutFailed": "Checkout failed",

  // ── Page header ──────────────────────────────────────────────────────
  "subs.header.title": "Subscriptions",
  "subs.header.desc": "Manage your restaurant locations and billing. Each workspace is one location.",
  "subs.addWorkspace": "+ Add workspace",
  "subs.upgrade.title": "Free trials include one workspace. Subscribe to add multiple restaurant locations.",
  "subs.badge.trial": "Trial",
  "subs.upgrade.cta": "Upgrade to add workspaces",

  // ── Billing summary card ─────────────────────────────────────────────
  "subs.billing.pendingCancel": "Pending cancel",
  "subs.billing.currentPlan": "Current plan",
  "subs.billing.per.year": "year",
  "subs.billing.per.month": "month",
  "subs.billing.plan.annual": "Annual",
  "subs.billing.plan.monthly": "Monthly",
  "subs.billing.billableWorkspace": "billable workspace",
  "subs.billing.billableWorkspaces": "billable workspaces",
  "subs.billing.pendingCancelParen.prefix": " (",
  "subs.billing.pendingCancelParen.suffix": " pending cancel)",
  "subs.billing.cancelsPrefix": "Cancels ",
  "subs.billing.renewsPrefix": "Renews ",
  "subs.billing.keepSubscription": "Keep subscription",
  "subs.confirm.keepSub.title": "Keep your subscription?",
  "subs.confirm.keepSub.bodyPrefix": "Your subscription will continue normally. All ",
  "subs.confirm.keepSub.bodyWorkspace": " workspace",
  "subs.confirm.keepSub.bodyWorkspaces": " workspaces",
  "subs.confirm.keepSub.bodySuffix": " will stay active. No charge.",
  "subs.confirm.keepSub.confirmLabel": "Keep subscription",

  // ── Active workspaces list ───────────────────────────────────────────
  "subs.section.workspaces": "Workspaces",
  "subs.rename.save": "Save",
  "subs.rename.cancel": "Cancel",
  "subs.rename.tooltip": "Rename workspace",
  "subs.pill.uae": "UAE",
  "subs.pill.uk": "UK",
  "subs.pill.us": "US",
  "subs.pill.in": "India",
  "subs.cancelPrefix": "CANCEL ",
  "subs.price.noFutureCharges": "No future charges",
  "subs.price.accessUntilCancel": "Access until cancel date",
  "subs.price.perMo": " /mo",
  "subs.price.firstSite": "First site",
  "subs.btn.keep": "Keep",
  "subs.btn.cancel": "Cancel",

  // ── Keep / cancel / delete confirm dialogs (active rows) ─────────────
  "subs.confirm.keepWs.subCancelOther.a": "Your subscription is set to cancel. Keeping ",
  "subs.confirm.keepWs.subCancelOther.b": " will reactivate your subscription — ",
  "subs.confirm.keepWs.subCancelOther.c": " stays active. The other ",
  "subs.confirm.keepWs.subCancelOther.dWorkspace": " workspace",
  "subs.confirm.keepWs.subCancelOther.dWorkspaces": " workspaces",
  "subs.confirm.keepWs.subCancelOther.e": " (",
  "subs.confirm.keepWs.subCancelOther.f": ") will still be archived on ",
  "subs.confirm.keepWs.subCancelOther.g": ".",
  "subs.confirm.keepWs.subCancel.a": "Your subscription is set to cancel. Keeping ",
  "subs.confirm.keepWs.subCancel.b": " will reactivate your subscription and ",
  "subs.confirm.keepWs.subCancel.c": " stays active.",
  "subs.confirm.keepWs.plain": "The scheduled cancellation will be removed. No charge — your subscription continues unchanged.",
  "subs.confirm.keepWs.titlePrefix": "Keep ",
  "subs.confirm.keepWs.titleSuffix": "?",
  "subs.confirm.keepWs.confirmPrefix": "Keep ",

  "subs.confirm.deleteWs.titlePrefix": "Delete ",
  "subs.confirm.deleteWs.titleSuffix": "?",
  "subs.confirm.deleteWs.body": "This workspace and its data will be removed. Since you haven't subscribed yet, no billing is affected. You can create another workspace anytime during your trial.",
  "subs.confirm.deleteWs.confirmLabel": "Delete workspace",
  "subs.confirm.keepIt": "Keep it",

  "subs.confirm.cancelSub.title": "Cancel your subscription?",
  "subs.confirm.cancelSub.bodyPrefix": " is your only active workspace. Cancelling it will end your entire Netrev subscription. We'll open the Stripe billing portal where you can confirm — your workspace stays active until the end of your current billing period.",
  "subs.confirm.cancelSub.confirmLabel": "Continue to Stripe →",

  "subs.confirm.cancelWs.titlePrefix": "Cancel ",
  "subs.confirm.cancelWs.titleSuffix": "?",
  "subs.confirm.cancelWs.body": "This workspace will remain active until the end of your current billing period, then be archived. You'll be charged for it through that date (no partial refund). You can restore it within 90 days.",
  "subs.confirm.cancelWs.confirmLabel": "Cancel workspace",

  // ── Archived workspaces ──────────────────────────────────────────────
  "subs.section.archived": "Archived",
  "subs.archived.retentionNote": "Read-only · restorable within 90 days",
  "subs.archived.pill": "Archived",
  "subs.archived.metaPrefix": "Archived ",
  "subs.archived.metaDay": " day",
  "subs.archived.metaDays": " days",
  "subs.archived.metaSuffix": " retention left",
  "subs.confirm.restore.subCancelOther.a": "Your subscription is set to cancel. Restoring ",
  "subs.confirm.restore.subCancelOther.b": " will reactivate your subscription and add ",
  "subs.confirm.restore.subCancelOther.c": " back. The ",
  "subs.confirm.restore.subCancelOther.dWorkspace": " other workspace",
  "subs.confirm.restore.subCancelOther.dWorkspaces": " other workspaces",
  "subs.confirm.restore.subCancelOther.e": " set to cancel will still be archived at period end. Restoring costs a prorated charge for the remainder of this billing period.",
  "subs.confirm.restore.subCancel.a": "Your subscription is set to cancel. Restoring ",
  "subs.confirm.restore.subCancel.b": " will reactivate your subscription and add it back, with a prorated charge for the remainder of the current period.",
  "subs.confirm.restore.plain.a": " will be added back to your subscription, with a prorated charge for the remainder of the current billing period.",
  "subs.confirm.restore.titlePrefix": "Restore ",
  "subs.confirm.restore.titleSuffix": "?",
  "subs.confirm.restore.confirmReactivate": "Reactivate & restore",
  "subs.confirm.restore.confirm": "Restore",
  "subs.btn.restore": "Restore",

  // ── Empty state (no workspaces) ──────────────────────────────────────
  "subs.empty.title": "Add your first location",
  "subs.empty.desc": "Each location gets its own P&L dashboard, daily log, and menu pricing tool.",

  // ── Add workspace form ───────────────────────────────────────────────
  "subs.form.newWorkspace": "New workspace",
  "subs.form.trialNote": "7-day free trial · No card needed to start",
  "subs.form.stepPrefix": "Step ",
  "subs.form.stepMid": " of ",
  "subs.form.selectMarket": "Select your market ",
  "subs.form.superAdminOverride": "· Super admin override",
  "subs.market.uk": "United Kingdom",
  "subs.market.uae": "United Arab Emirates",
  "subs.market.us": "United States",
  "subs.market.in": "India",
  "subs.market.label.uk": "🇬🇧 United Kingdom",
  "subs.market.label.uae": "🇦🇪 United Arab Emirates",
  "subs.market.label.us": "🇺🇸 United States",
  "subs.market.label.in": "🇮🇳 India",
  "subs.form.regionLocked.prefix": "Region locked to your account · Billed in ",
  "subs.form.label.brand": "Brand / restaurant name",
  "subs.form.placeholder.brand": "e.g. Burger Bite",
  "subs.form.label.city": "City",
  "subs.form.city.select": "Select city...",
  "subs.form.city.other": "Other...",
  "subs.form.city.typeName": "Type city name",
  "subs.form.label.area": "Area / district (optional)",
  "subs.form.placeholder.area.uae": "e.g. JBR, DIFC, Downtown, Marina",
  "subs.form.placeholder.area.uk": "e.g. City Centre, Evington, Northern Quarter",
  "subs.form.placeholder.area.us": "e.g. SoHo, Midtown, River North",
  "subs.form.placeholder.area.in": "e.g. Bandra, Koramangala, Connaught Place",
  "subs.form.freeTrial": "Free trial",
  "subs.form.selectAggregator": "Select one aggregator to begin",
  "subs.form.setRateInConfig": "You'll set your rate in Configuration",
  "subs.form.trialOnePlatformNote": "Your trial includes tracking for one aggregator platform. Subscribe to add all platforms across multiple locations.",
  "subs.form.allPlatformsIncluded": " All platforms included",
  "subs.form.setRatesInConfig": "You'll set your commission, VAT, and other rates in Configuration after setup.",
  "subs.form.continue": "Continue →",
  "subs.form.cancel": "Cancel",

  // ── Step 2: confirm ──────────────────────────────────────────────────
  "subs.confirmStep.title": "Confirm your workspace",
  "subs.confirmStep.row.market": "Market",
  "subs.confirmStep.row.workspace": "Workspace",
  "subs.confirmStep.row.platforms": "Platforms",
  "subs.confirmStep.row.currency": "Currency",
  "subs.confirmStep.price": "Price",
  "subs.confirmStep.cost": "Cost",
  "subs.confirmStep.freeOverride": "Free (override)",
  "subs.confirmStep.perMo": "/mo",
  "subs.confirmStep.freeDuringTrialPrefix": "Free during trial · ",
  "subs.confirmStep.perMoAfter": "/mo after",
  "subs.confirmStep.addedToSubSuffix": "/mo (added to subscription)",
  "subs.confirmStep.included": "Included",
  "subs.confirmStep.subRequired": "Subscription required",
  "subs.confirmStep.subRequired.desc": "Your trial has ended. Subscribe to create this workspace. You'll be redirected to Stripe.",
  "subs.confirmStep.freeDuringTrialBanner": "Free during your trial. After trial ends, pick which workspaces to keep.",
  "subs.confirmStep.addedToSubBanner.prefix": "Added to your subscription. Prorated to ",
  "subs.confirmStep.addedToSubBanner.suffix": "/mo on your next invoice.",
  "subs.confirmStep.superAdminNoCharge": "Super admin — no charge.",
  "subs.confirmStep.includedOnPlan": "Included on your current plan.",
  "subs.confirmStep.confirm.addPrefix": "Add ",
  "subs.confirmStep.confirm.addSuffix": "?",
  "subs.confirmStep.confirm.intro": "Adding a new restaurant means:",
  "subs.confirmStep.confirm.bullet1.prefix": "Your monthly bill goes up by ",
  "subs.confirmStep.confirm.bullet1.suffix": "/mo",
  "subs.confirmStep.confirm.bullet2": "A prorated amount is charged today for the rest of this billing cycle",
  "subs.confirmStep.confirm.bullet3.suffix": " is ready to use right away",
  "subs.confirmStep.confirm.modifyNote": "Can be modified in Manage billing.",
  "subs.confirmStep.confirm.label.addPrefix": "Add ",
  "subs.confirmStep.btn.processing": "Processing...",
  "subs.confirmStep.btn.continuePayment": "Continue to payment →",
  "subs.confirmStep.btn.addSite": "Add site to subscription",
  "subs.confirmStep.btn.createWorkspace": "Create workspace",
  "subs.confirmStep.btn.back": "← Back",
  "subs.overlay.creatingWorkspace": "Creating workspace…",
};

export const ar = {
  // ── CardRequiredModal ────────────────────────────────────────────────
  "subs.card.heading": "أضف وسيلة دفع لبدء الفترة التجريبية",
  "subs.card.createOnReturn.prefix": "سننشئ ",
  "subs.card.createOnReturn.suffix": " فور عودتك.",
  "subs.card.createWorkspaceOnReturn": "سننشئ مساحة عملك فور عودتك.",
  "subs.card.plan.monthly": "شهري",
  "subs.card.plan.annualFree": "سنوي · شهر مجاني",
  "subs.card.firstSite": "الموقع الأول",
  "subs.card.per.year": "سنة",
  "subs.card.per.month": "شهر",
  "subs.card.noChargeToday": "لا رسوم اليوم.",
  "subs.card.trialNote": " تبدأ الفوترة فقط عند انتهاء فترتك التجريبية البالغة 7 أيام — يمكنك الإلغاء في أي وقت قبل ذلك.",
  "subs.card.cta.redirecting": "جارٍ التحويل إلى Stripe…",
  "subs.card.cta.addStartTrial": "أضف وسيلة دفع · ابدأ الفترة التجريبية ←",
  "subs.card.cta.skipTrial": "تخطَّ الفترة التجريبية · ادفع الآن واحصل على وصول كامل",
  "subs.card.cta.maybeLater": "ربما لاحقًا · سأضيف بطاقة قبل إنشاء مساحة العمل",
  "subs.card.err.notAuthenticated": "غير مصادق عليه",
  "subs.card.err.checkoutFailed": "فشل الدفع",
  "subs.card.err.noCheckoutUrl": "لم يتم إرجاع رابط الدفع",
  "subs.card.alert.alreadySubscribed": "لديك اشتراك فعّال بالفعل. جارٍ التحديث لتحميله.",

  // ── Alerts / errors (createWorkspace + actions) ──────────────────────
  "subs.alert.trialOneWorkspace": "يمكن لمستخدمي الفترة التجريبية إنشاء مساحة عمل واحدة فقط. اشترك أو تخطَّ الفترة التجريبية لإضافة المزيد.",
  "subs.alert.freeOverrideOneWorkspace": "يشمل الوصول المجاني مساحة عمل واحدة. اشترك لإضافة المزيد من مساحات العمل.",
  "subs.alert.saveFailed": "تعذّر حفظ مساحة العمل. تحقّق من اتصالك وحاول مرة أخرى.",
  "subs.alert.sessionExpired": "انتهت صلاحية جلستك. يرجى تسجيل الدخول مرة أخرى لإنشاء مساحات العمل.",
  "subs.alert.couldNotDeletePrefix": "تعذّر حذف مساحة العمل: ",
  "subs.alert.cardCouldNotCharge": "تعذّر خصم المبلغ من بطاقتك. لم يتم إنشاء مساحة العمل. يرجى تحديث وسيلة الدفع في إدارة الفوترة والمحاولة مرة أخرى.",
  "subs.alert.createFailed": "تعذّر إنشاء مساحة العمل.",
  "subs.alert.createFailedRetry": "تعذّر إنشاء مساحة العمل. يرجى المحاولة مرة أخرى.",
  "subs.alert.trialEndedSubscribe": "انتهت فترتك التجريبية. يرجى الاشتراك لاستعادة مساحة العمل هذه.",
  "subs.err.nameEmpty": "لا يمكن أن يكون الاسم فارغًا",
  "subs.err.couldntSaveName": "تعذّر حفظ الاسم",
  "subs.err.failedReactivate": "تعذّرت إعادة التفعيل",
  "subs.err.failed": "فشل",
  "subs.err.failedDeleteWorkspace": "تعذّر حذف مساحة العمل",
  "subs.err.couldNotOpenPortal": "تعذّر فتح بوابة الفوترة",
  "subs.err.lastWorkspaceManageBilling": "هذه مساحة العمل الوحيدة المتبقية لديك. استخدم 'إدارة الفوترة' لإلغاء اشتراكك بالكامل.",
  "subs.err.cancelFailed": "فشل الإلغاء",
  "subs.err.checkoutFailed": "فشل الدفع",

  // ── Page header ──────────────────────────────────────────────────────
  "subs.header.title": "الاشتراكات",
  "subs.header.desc": "أدِر مواقع مطعمك والفوترة. كل مساحة عمل تمثّل موقعًا واحدًا.",
  "subs.addWorkspace": "+ إضافة مساحة عمل",
  "subs.upgrade.title": "تشمل الفترات التجريبية المجانية مساحة عمل واحدة. اشترك لإضافة مواقع مطاعم متعددة.",
  "subs.badge.trial": "تجريبي",
  "subs.upgrade.cta": "الترقية لإضافة مساحات عمل",

  // ── Billing summary card ─────────────────────────────────────────────
  "subs.billing.pendingCancel": "إلغاء معلّق",
  "subs.billing.currentPlan": "الخطة الحالية",
  "subs.billing.per.year": "سنة",
  "subs.billing.per.month": "شهر",
  "subs.billing.plan.annual": "سنوي",
  "subs.billing.plan.monthly": "شهري",
  "subs.billing.billableWorkspace": "مساحة عمل قابلة للفوترة",
  "subs.billing.billableWorkspaces": "مساحات عمل قابلة للفوترة",
  "subs.billing.pendingCancelParen.prefix": " (",
  "subs.billing.pendingCancelParen.suffix": " إلغاء معلّق)",
  "subs.billing.cancelsPrefix": "يُلغى في ",
  "subs.billing.renewsPrefix": "يُجدَّد في ",
  "subs.billing.keepSubscription": "الإبقاء على الاشتراك",
  "subs.confirm.keepSub.title": "هل تريد الإبقاء على اشتراكك؟",
  "subs.confirm.keepSub.bodyPrefix": "سيستمر اشتراكك بشكل طبيعي. ستظل جميع مساحات العمل البالغة ",
  "subs.confirm.keepSub.bodyWorkspace": " مساحة عمل",
  "subs.confirm.keepSub.bodyWorkspaces": " مساحات عمل",
  "subs.confirm.keepSub.bodySuffix": " فعّالة. لا رسوم.",
  "subs.confirm.keepSub.confirmLabel": "الإبقاء على الاشتراك",

  // ── Active workspaces list ───────────────────────────────────────────
  "subs.section.workspaces": "مساحات العمل",
  "subs.rename.save": "حفظ",
  "subs.rename.cancel": "إلغاء",
  "subs.rename.tooltip": "إعادة تسمية مساحة العمل",
  "subs.pill.uae": "الإمارات",
  "subs.pill.uk": "المملكة المتحدة",
  "subs.pill.us": "الولايات المتحدة",
  "subs.pill.in": "الهند",
  "subs.cancelPrefix": "إلغاء ",
  "subs.price.noFutureCharges": "لا رسوم مستقبلية",
  "subs.price.accessUntilCancel": "الوصول حتى تاريخ الإلغاء",
  "subs.price.perMo": " /شهر",
  "subs.price.firstSite": "الموقع الأول",
  "subs.btn.keep": "الإبقاء",
  "subs.btn.cancel": "إلغاء",

  // ── Keep / cancel / delete confirm dialogs (active rows) ─────────────
  "subs.confirm.keepWs.subCancelOther.a": "اشتراكك مضبوط على الإلغاء. الإبقاء على ",
  "subs.confirm.keepWs.subCancelOther.b": " سيعيد تفعيل اشتراكك — ",
  "subs.confirm.keepWs.subCancelOther.c": " يظل فعّالًا. أما مساحات العمل الأخرى البالغة ",
  "subs.confirm.keepWs.subCancelOther.dWorkspace": " مساحة عمل",
  "subs.confirm.keepWs.subCancelOther.dWorkspaces": " مساحات عمل",
  "subs.confirm.keepWs.subCancelOther.e": " (",
  "subs.confirm.keepWs.subCancelOther.f": ") فستظل مؤرشفة في ",
  "subs.confirm.keepWs.subCancelOther.g": ".",
  "subs.confirm.keepWs.subCancel.a": "اشتراكك مضبوط على الإلغاء. الإبقاء على ",
  "subs.confirm.keepWs.subCancel.b": " سيعيد تفعيل اشتراكك و",
  "subs.confirm.keepWs.subCancel.c": " يظل فعّالًا.",
  "subs.confirm.keepWs.plain": "ستتم إزالة الإلغاء المجدول. لا رسوم — يستمر اشتراكك دون تغيير.",
  "subs.confirm.keepWs.titlePrefix": "الإبقاء على ",
  "subs.confirm.keepWs.titleSuffix": "؟",
  "subs.confirm.keepWs.confirmPrefix": "الإبقاء على ",

  "subs.confirm.deleteWs.titlePrefix": "حذف ",
  "subs.confirm.deleteWs.titleSuffix": "؟",
  "subs.confirm.deleteWs.body": "ستتم إزالة مساحة العمل هذه وبياناتها. بما أنك لم تشترك بعد، لن تتأثر الفوترة. يمكنك إنشاء مساحة عمل أخرى في أي وقت خلال فترتك التجريبية.",
  "subs.confirm.deleteWs.confirmLabel": "حذف مساحة العمل",
  "subs.confirm.keepIt": "الإبقاء عليها",

  "subs.confirm.cancelSub.title": "هل تريد إلغاء اشتراكك؟",
  "subs.confirm.cancelSub.bodyPrefix": " هي مساحة العمل الفعّالة الوحيدة لديك. إلغاؤها سينهي اشتراكك بالكامل في Netrev. سنفتح بوابة فوترة Stripe حيث يمكنك التأكيد — تظل مساحة عملك فعّالة حتى نهاية فترة الفوترة الحالية.",
  "subs.confirm.cancelSub.confirmLabel": "المتابعة إلى Stripe ←",

  "subs.confirm.cancelWs.titlePrefix": "إلغاء ",
  "subs.confirm.cancelWs.titleSuffix": "؟",
  "subs.confirm.cancelWs.body": "ستظل مساحة العمل هذه فعّالة حتى نهاية فترة الفوترة الحالية، ثم تُؤرشف. ستُحاسب عليها حتى ذلك التاريخ (دون استرداد جزئي). يمكنك استعادتها خلال 90 يومًا.",
  "subs.confirm.cancelWs.confirmLabel": "إلغاء مساحة العمل",

  // ── Archived workspaces ──────────────────────────────────────────────
  "subs.section.archived": "المؤرشفة",
  "subs.archived.retentionNote": "للقراءة فقط · قابلة للاستعادة خلال 90 يومًا",
  "subs.archived.pill": "مؤرشفة",
  "subs.archived.metaPrefix": "أُرشفت في ",
  "subs.archived.metaDay": " يوم",
  "subs.archived.metaDays": " يومًا",
  "subs.archived.metaSuffix": " متبقٍ للاحتفاظ",
  "subs.confirm.restore.subCancelOther.a": "اشتراكك مضبوط على الإلغاء. استعادة ",
  "subs.confirm.restore.subCancelOther.b": " ستعيد تفعيل اشتراكك وتضيف ",
  "subs.confirm.restore.subCancelOther.c": " مرة أخرى. أما ",
  "subs.confirm.restore.subCancelOther.dWorkspace": " مساحة العمل الأخرى",
  "subs.confirm.restore.subCancelOther.dWorkspaces": " مساحات العمل الأخرى",
  "subs.confirm.restore.subCancelOther.e": " المضبوطة على الإلغاء فستظل مؤرشفة في نهاية الفترة. تُكلّف الاستعادة رسومًا تناسبية عن المدة المتبقية من فترة الفوترة هذه.",
  "subs.confirm.restore.subCancel.a": "اشتراكك مضبوط على الإلغاء. استعادة ",
  "subs.confirm.restore.subCancel.b": " ستعيد تفعيل اشتراكك وتضيفها مرة أخرى، مع رسوم تناسبية عن المدة المتبقية من الفترة الحالية.",
  "subs.confirm.restore.plain.a": " ستُضاف مرة أخرى إلى اشتراكك، مع رسوم تناسبية عن المدة المتبقية من فترة الفوترة الحالية.",
  "subs.confirm.restore.titlePrefix": "استعادة ",
  "subs.confirm.restore.titleSuffix": "؟",
  "subs.confirm.restore.confirmReactivate": "إعادة التفعيل والاستعادة",
  "subs.confirm.restore.confirm": "استعادة",
  "subs.btn.restore": "استعادة",

  // ── Empty state (no workspaces) ──────────────────────────────────────
  "subs.empty.title": "أضف موقعك الأول",
  "subs.empty.desc": "يحصل كل موقع على لوحة أرباح وخسائر خاصة به، وسجل يومي، وأداة تسعير القائمة.",

  // ── Add workspace form ───────────────────────────────────────────────
  "subs.form.newWorkspace": "مساحة عمل جديدة",
  "subs.form.trialNote": "فترة تجريبية مجانية لمدة 7 أيام · لا حاجة لبطاقة للبدء",
  "subs.form.stepPrefix": "الخطوة ",
  "subs.form.stepMid": " من ",
  "subs.form.selectMarket": "اختر سوقك ",
  "subs.form.superAdminOverride": "· تجاوز كبير المسؤولين",
  "subs.market.uk": "المملكة المتحدة",
  "subs.market.uae": "الإمارات العربية المتحدة",
  "subs.market.us": "الولايات المتحدة",
  "subs.market.in": "الهند",
  "subs.market.label.uk": "🇬🇧 المملكة المتحدة",
  "subs.market.label.uae": "🇦🇪 الإمارات العربية المتحدة",
  "subs.market.label.us": "🇺🇸 الولايات المتحدة",
  "subs.market.label.in": "🇮🇳 الهند",
  "subs.form.regionLocked.prefix": "المنطقة مقيّدة بحسابك · تُفوتر بعملة ",
  "subs.form.label.brand": "اسم العلامة التجارية / المطعم",
  "subs.form.placeholder.brand": "مثال: Burger Bite",
  "subs.form.label.city": "المدينة",
  "subs.form.city.select": "اختر المدينة...",
  "subs.form.city.other": "أخرى...",
  "subs.form.city.typeName": "اكتب اسم المدينة",
  "subs.form.label.area": "المنطقة / الحي (اختياري)",
  "subs.form.placeholder.area.uae": "مثال: JBR، DIFC، Downtown، Marina",
  "subs.form.placeholder.area.uk": "مثال: City Centre، Evington، Northern Quarter",
  "subs.form.placeholder.area.us": "مثال: SoHo، Midtown، River North",
  "subs.form.placeholder.area.in": "مثال: Bandra، Koramangala، Connaught Place",
  "subs.form.freeTrial": "فترة تجريبية مجانية",
  "subs.form.selectAggregator": "اختر منصّة تجميع واحدة للبدء",
  "subs.form.setRateInConfig": "ستحدّد نسبتك في الإعدادات",
  "subs.form.trialOnePlatformNote": "تشمل فترتك التجريبية التتبّع لمنصّة تجميع واحدة. اشترك لإضافة جميع المنصّات عبر مواقع متعددة.",
  "subs.form.allPlatformsIncluded": " جميع المنصّات مشمولة",
  "subs.form.setRatesInConfig": "ستحدّد عمولتك وضريبة القيمة المضافة وغيرها من النسب في الإعدادات بعد الإعداد.",
  "subs.form.continue": "متابعة ←",
  "subs.form.cancel": "إلغاء",

  // ── Step 2: confirm ──────────────────────────────────────────────────
  "subs.confirmStep.title": "أكّد مساحة عملك",
  "subs.confirmStep.row.market": "السوق",
  "subs.confirmStep.row.workspace": "مساحة العمل",
  "subs.confirmStep.row.platforms": "المنصّات",
  "subs.confirmStep.row.currency": "العملة",
  "subs.confirmStep.price": "السعر",
  "subs.confirmStep.cost": "التكلفة",
  "subs.confirmStep.freeOverride": "مجاني (تجاوز)",
  "subs.confirmStep.perMo": "/شهر",
  "subs.confirmStep.freeDuringTrialPrefix": "مجاني خلال الفترة التجريبية · ",
  "subs.confirmStep.perMoAfter": "/شهر بعدها",
  "subs.confirmStep.addedToSubSuffix": "/شهر (مضاف إلى الاشتراك)",
  "subs.confirmStep.included": "مشمول",
  "subs.confirmStep.subRequired": "الاشتراك مطلوب",
  "subs.confirmStep.subRequired.desc": "انتهت فترتك التجريبية. اشترك لإنشاء مساحة العمل هذه. ستتم إعادة توجيهك إلى Stripe.",
  "subs.confirmStep.freeDuringTrialBanner": "مجاني خلال فترتك التجريبية. بعد انتهاء الفترة التجريبية، اختر مساحات العمل التي تريد الإبقاء عليها.",
  "subs.confirmStep.addedToSubBanner.prefix": "مضاف إلى اشتراكك. مُحتسب تناسبيًا بمقدار ",
  "subs.confirmStep.addedToSubBanner.suffix": "/شهر في فاتورتك التالية.",
  "subs.confirmStep.superAdminNoCharge": "كبير المسؤولين — لا رسوم.",
  "subs.confirmStep.includedOnPlan": "مشمول في خطتك الحالية.",
  "subs.confirmStep.confirm.addPrefix": "إضافة ",
  "subs.confirmStep.confirm.addSuffix": "؟",
  "subs.confirmStep.confirm.intro": "إضافة مطعم جديد تعني:",
  "subs.confirmStep.confirm.bullet1.prefix": "تزداد فاتورتك الشهرية بمقدار ",
  "subs.confirmStep.confirm.bullet1.suffix": "/شهر",
  "subs.confirmStep.confirm.bullet2": "يُحتسب مبلغ تناسبي اليوم عن بقية دورة الفوترة هذه",
  "subs.confirmStep.confirm.bullet3.suffix": " جاهز للاستخدام فورًا",
  "subs.confirmStep.confirm.modifyNote": "يمكن تعديله في إدارة الفوترة.",
  "subs.confirmStep.confirm.label.addPrefix": "إضافة ",
  "subs.confirmStep.btn.processing": "جارٍ المعالجة...",
  "subs.confirmStep.btn.continuePayment": "المتابعة إلى الدفع ←",
  "subs.confirmStep.btn.addSite": "إضافة موقع إلى الاشتراك",
  "subs.confirmStep.btn.createWorkspace": "إنشاء مساحة عمل",
  "subs.confirmStep.btn.back": "→ رجوع",
  "subs.overlay.creatingWorkspace": "جارٍ إنشاء مساحة العمل…",
};
